// extracted by mini-css-extract-plugin
export default {"dialogs":"Dialogs_dialogs__I+zZ5","empty":"Dialogs_empty__3JJO9"};